import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <React.Fragment>
      <div className='row footer'>
        <div className='col-md-6 footer-left'>
          <div className='footer-social-icons'>
            <div className='icon'>
              <i className='fab fa-instagram'></i>
            </div>
            <div className='icon'>
              <i className='fab fa-facebook-f'></i>
            </div>
          </div>

          <div className='footer-left-menu'>
            Contact Delivery <br />
            Returns <br />
            Information <br />
            Warranty Terms
            <br />
            Conditions <br />
            Privacy Policy
          </div>
        </div>

        <div className='col-md-6 footer-right'>
          <p>Create account to start ordering</p>
          <Link to='/signup/'>
            <button>Create account</button>
          </Link>
        </div>
      </div>

      <div className='row footer-bottom'>
        <div className='col-md-6 footer-bottom-left'>
          <p>© Beverix {new Date().getFullYear()}. | All Rights Reserved</p>
        </div>

        <div className='col-md-6 footer-bottom-right'>
          <p>Part of Coca-Cola Ltd.</p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Footer;
